/* eslint-disable react-hooks/exhaustive-deps */
import { Checkbox, Spin} from "antd";
import React, { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { closingActions } from "../../TransactionReport/state/actions";
import { contractDataHandle } from "../../CreateOffer/state/actions";
import moment from "moment";
import styles from "../style/SendEmailModal.module.css"
import { buyerCustomerDocsContractTypes, customerDocsContractTypes, listingContractTypes, otherDocsContractTypes } from "../commondata/commonData";
import ContractTypeBadge from "./ContractTypeBadge";
import { formatBaseName, formatDocName } from "../utils/universalFuntions";
import { FaRegFilePdf } from "react-icons/fa";
import { FileImageOutlined} from "@ant-design/icons";

const DocumentList = ({ isSmallScreen,role, isMediumScreen, data, setData, screenSource, selectedData, section, documentId, selectedStatus, RTDInitiator, offerId, contractAuthKey, rootDocData }) => {
  
  const { getTransactionLaneData } = useSelector((state) => state.rtdTransactionLane);
  const { sharedDocs, sharedDocsLoading, sharedDocsError } = useSelector((state) => state.transactionReport);
  let { propertyDocs, contactDocs, propertDocsLoading, propertDocsError, personDocs, personDocsLoading, personDocsError } = useSelector((state) => state.createOffer, shallowEqual);
  const dispatch = useDispatch();
 const listingAndAmendExtendCotractTypes = [...listingContractTypes, "LCAES"];
const isTxnDoc = (ele) => listingAndAmendExtendCotractTypes.includes(ele?.contractType) || ele?.hasOwnProperty("isShared") || !!ele?.offerId || ele?.contractType?.startsWith("HH_")||ele?.isResureSignDoc;
  useEffect(() => {
    let unmounted = {
      value: false,
    };
    let source = axios.CancelToken.source();
    if (customerDocsContractTypes.includes(rootDocData?.contractType)) {
      let localData = JSON.parse(localStorage.getItem(rootDocData.urlId) || "{}") || {};
      let customerIds = [];
      const clientIds = buyerCustomerDocsContractTypes.includes(rootDocData?.contractType) ? localData.Buyers || [] : localData.Sellers || [];
      clientIds?.forEach((client) => {
        if (client?.isCorp) {
          client.signers?.forEach((signer) => {
            if (signer?.personId?.length === 24) customerIds.push(signer.personId);
          });
        } else {
          if (client?.personId?.length === 24) customerIds.push(client.personId);
        }
      });
      dispatch(contractDataHandle.getPersonDocs({ customerIds, unmounted, source, contractAuthKey }));
    } else {
      if (offerId || screenSource === "SELLING_RTD") {
        const openFor = (screenSource === "SELLING_RTD" || screenSource === "CONTRACT_NAV_SELLER_AGENT") ? "SELLER_AGENT" : "BUYER_AGENT";
        dispatch(closingActions.getSharedDocs(offerId, contractAuthKey, openFor));
      }
      let params = {};
      if (screenSource === "SELLING_RTD") {
        params = {
          ...(selectedData?.offerId ? { offerId: selectedData?.offerId } : {}),
          ...(selectedData?.propertyId ? { propertyId: selectedData?.propertyId } : {}),
          openFor: (screenSource === "SELLING_RTD" || screenSource === "CONTRACT_NAV_SELLER_AGENT") ? "SELLER_AGENT" : "BUYER_AGENT",
          section: "SEND_DOCUMENT",
          queryPlatform:"WEB",
        };
      } else {
        params = {
          ...(rootDocData?.offerId ? { offerId: rootDocData?.offerId } : {}),
          ...(rootDocData?.propertyId ? { propertyId: rootDocData?.propertyId } : {}),
          openFor: (screenSource === "SELLING_RTD" || screenSource === "CONTRACT_NAV_SELLER_AGENT") ? "SELLER_AGENT" : "BUYER_AGENT",
          section: "SEND_DOCUMENT",
          queryPlatform:"WEB",
          ...(otherDocsContractTypes.includes(rootDocData?.contractType)? {contractType:"OTHER_DOCS", documentId:rootDocData?.documentId}:{})
        };
      }
      dispatch(contractDataHandle.getPropertyDocsFun({ params, unmounted, source, contractAuthKey }));
    }

    return () => {
      unmounted.value = true;
      source.cancel("Cancelling in cleanup");
    };
  }, []);

  const getClientDocName = (data={}, name="") => {
    let { contractType, transactionData = {}, docCreatedCount } = data;
    let baseName = docCreatedCount > 1 ? `${name}_${docCreatedCount - 1}` : name;
    switch (contractType) {
      case "ERTL":
      case "ETCT":
      case "ERTB":
      case "CB_ERTB": {
        let startDate = transactionData?.ListingPeriodBeginDate ? moment(transactionData?.ListingPeriodBeginDate).format("MM/DD/YYYY, h:mm A") : "";
        let endDate = transactionData?.ListingPeriodEndByDate ? moment(transactionData?.ListingPeriodEndByDate).format("MM/DD/YYYY, h:mm A") : "";
        return startDate && endDate ? `${baseName} ${startDate} - ${endDate} ` : startDate ? `${baseName} ${startDate}` : endDate ? `${baseName} ${endDate}` : `${baseName}`;
      }
      case "LCAE":
      case "WY_ATAE_ERTB":
      case "LCAES_ETCT":
      case "LCAES_ERTL":
      case "WY_ARPMA": {
       const dateTime = data?.createdAt ? moment(data?.createdAt).format("MM/DD/YYYY, h:mm A") : "";
        const endDate = transactionData?.ListingPeriodEndByDate ? moment(transactionData?.ListingPeriodEndByDate).format("MM/DD/YYYY, h:mm A") : "";
        const nestedDocBaseName = docCreatedCount > 1 ? `Amend/Extend_${docCreatedCount - 1}` : `Amend/Extend ${dateTime}`;
        return endDate ? `${nestedDocBaseName} -  ${endDate}` : `Amend/Extend ${dateTime}`;
      }
      default:
        let dateTime = data?.createdAt ? moment(data?.createdAt).format("MM/DD/YYYY, h:mm A") : "";
        return `${baseName} ${dateTime}`;
    }
  };
  
  const mapClientDocs = (docsTabDoraDocs, propertyDocsData) => {
    let clientDocuments = [];

    docsTabDoraDocs?.forEach((doc) => {
      if (doc.createdDocuments?.length > 0) {
        doc.createdDocuments.forEach((subDoc) => {
          subDoc.contractName = getClientDocName(subDoc, doc?.name);
          clientDocuments.push(subDoc);
          if (subDoc.matchedDocuments?.length > 0) {
            subDoc.matchedDocuments.forEach((matchDocument) => {
              matchDocument.contractName = getClientDocName(matchDocument);
              matchDocument.isSecondLevel = true;
              clientDocuments.push(matchDocument);
            });
          }
        });
      }
    });

    return clientDocuments;
  };
  const clientDocs = mapClientDocs(personDocs);


  const transactionAndPropertyDocs = useMemo(() => {
    return propertyDocs?.filter(isTxnDoc);
  }, [propertyDocs, listingAndAmendExtendCotractTypes]);

  const transactionDocIds = useMemo(() => {
    return new Set(transactionAndPropertyDocs?.map((doc) => doc._id));
  }, [transactionAndPropertyDocs]);

  const withoutBuyerDocs = useMemo(() => {
    return propertyDocs?.filter((ele) => !transactionDocIds.has(ele._id)&& !ele?.isResureSignDoc);
  }, [propertyDocs, transactionDocIds]);

  useEffect(() => {
    let propertyDocuments;
    const filteredClientContracts = clientDocs?.filter((contract) => contract._id === rootDocData?.documentId);

    if (screenSource === "SELLING_RTD") {
      propertyDocuments = propertyDocs?.filter((contract) => contract?.documentId === documentId);
    } else {
      propertyDocuments = propertyDocs?.filter((contract) => contract.documentId === rootDocData?.documentId);
    }
    if (filteredClientContracts && filteredClientContracts.length > 0) {
      const documentDetails = filteredClientContracts
        .map((contract) => ({
          documentId: contract?._id,
          sentBy: buyerCustomerDocsContractTypes.includes(contract?.contractType) ? "BUYER_AGENT" : "SELLER_AGENT",
        }))
        .filter(({ documentId, sentBy }) => documentId !== undefined && sentBy !== undefined);

     const documentNames =
       filteredClientContracts
         .filter((ele) => documentDetails?.some((d) => d.documentId === ele._id))
         .map((ele) => ({
           documentName: formatDocName(ele, { nameKey: "contractName" }),
           documentId: ele._id,
           updatedName: ele.updatedName || null,
         })) || [];
      // Update state with the filtered documentDetails
      setData((prevState) => ({
        ...prevState,
        clientDocumentSelected: documentDetails,
        documentNames: [...(prevState?.documentNames || []), ...documentNames],
      }));
    }

    if (propertyDocuments && propertyDocuments.length > 0) {
      const documentIds = propertyDocuments
        .filter(isTxnDoc)
        .map((contract) => contract.documentId)
        .filter((documentId) => documentId !== undefined);

      let documentNames =
        propertyDocuments
          .filter((ele) => documentIds.includes(ele?.documentId))
          .map((ele) => ({
            documentName: formatDocName(ele, { nameKey: "contractName" }),
            documentId: ele?.documentId,
            updatedName: ele?.updatedName || null,
          })) || [];

      // Update state with the filtered documentIds
      setData((prevState) => ({
        ...prevState,
        propertyDocsSelected: documentIds,
        documentNames: [...(prevState?.documentNames || []), ...documentNames],
      }));
    }

    if (propertyDocuments && propertyDocuments.length > 0) {
      const documentIds = propertyDocuments
        .filter((ele) => !isTxnDoc(ele))
        .map((contract) => contract.documentId)
        .filter((documentId) => documentId !== undefined);

      let documentNames =
        propertyDocuments
          .filter((ele) => documentIds.includes(ele?.documentId))
          .map((ele) => ({
            documentName: formatDocName(ele, { nameKey: "contractName" }),
            documentId: ele?.documentId,
          })) || [];

      // Filter out documentNames that are already included in data.documentNames
      documentNames = documentNames?.filter((ele) => !(data?.documentNames || [])?.includes(ele?.documentId)) || [];

      setData((prevState) => ({
        ...prevState,
        documentWithoutBuyerSelected: documentIds,
        documentNames: [...(prevState?.documentNames || []), ...documentNames],
      }));
    }
  }, [getTransactionLaneData, personDocs, propertyDocs]);

  console.log({data})

  const handleClientDocChange = (documentId, sentBy, document ) => {
    // Create a new array of clientDocumentSelected
    let flag = [...data?.clientDocumentSelected];

    // Create an object with documentId
    const newDoc = { documentId, sentBy };

    // Check if the documentId already exists in the array
    const index = flag.findIndex((item) => item.documentId === documentId);

    let newSelectedDocs;
    if (index !== -1) {
      // Remove the existing document object from the array
      newSelectedDocs = flag.filter((_, i) => i !== index);
    } else {
      // Add the new document object to the array
      newSelectedDocs = [...flag, newDoc];
    }
const documentName = formatDocName(document, { nameKey: "contractName" })
    // Update the state with the new array
    setData({
      ...data,
      clientDocumentSelected: newSelectedDocs,
      documentNames: index !== -1
        ? (data?.documentNames || [])?.filter(doc => doc?.documentId !== documentId) // 🔄 Remove if unchecked
        : [...(data?.documentNames || []), { documentName, documentId,  }] // ✅ Add if checked
    });
  };

  const handleCustomerDocs = (documentId, document) => {
    let flag = [...data?.customerDocumentSelected];
    const isItPresentInTheSelectedDoc = flag?.includes(documentId);
    const value = isItPresentInTheSelectedDoc ? { customerDocumentSelected: flag?.filter((id) => id !== documentId) } : { customerDocumentSelected: [...flag, documentId] };
    const documentName = formatDocName(document, { nameKey: "contractName" });
    setData({
      ...data,
      ...value,
      documentNames: isItPresentInTheSelectedDoc
        ? (data?.documentNames || [])?.filter((doc) => doc?.documentId !== documentId) // 🔄 Remove if unchecked
        : [...(data?.documentNames || []), { documentName, documentId }], // ✅ Add if checked
    });
  };

  const handleSharedDocs = (documentId, document) => {
    let flag = [...data?.sharedSelected];
    const isItPresentInTheSelectedDoc = flag?.includes(documentId);
    const value = isItPresentInTheSelectedDoc ? { sharedSelected: flag?.filter((id) => id !== documentId) } : { sharedSelected: [...flag, documentId] };
    const documentName = formatDocName(document, { nameKey: "fileName" });
    setData({
      ...data,
      ...value,
      documentNames: isItPresentInTheSelectedDoc
      ? (data?.documentNames || [])?.filter(doc => doc?.documentId !== documentId) // 🔄 Remove if unchecked
      : [...(data?.documentNames || []), { documentName, documentId }] // ✅ Add if checked
    });
  };

  const handlePropertyDocs = (documentId, type, document) => {
    let flag = [];
    let resureSignFlag = [...(data?.resureSignSelected || [])];
    if (type === "PROPETY_DOC") {
      flag = [...data?.propertyDocsSelected];
    } else if (type === "DOCUMENT_WITHOUT_BUYERS") {
      flag = [...data?.documentWithoutBuyerSelected];
    }
    
    const isItPresentInTheSelectedDoc = document?.isResureSignDoc
    ? resureSignFlag.includes(documentId)
    : flag?.includes(documentId);
    const value = isItPresentInTheSelectedDoc ? flag.filter((id) => id !== documentId) : [...flag, documentId];
    let updatedResureSign = resureSignFlag;
    if (document?.isResureSignDoc) {
      updatedResureSign = isItPresentInTheSelectedDoc
        ? resureSignFlag.filter((id) => id !== documentId)
        : [...resureSignFlag, documentId];
    }
    const documentName = formatDocName(document, { nameKey: "contractName" });

    setData({
      ...data,
      ...(type === "PROPETY_DOC"&& !document?.isResureSignDoc ? { propertyDocsSelected: value } : {}),
      ...(type === "DOCUMENT_WITHOUT_BUYERS" ? { documentWithoutBuyerSelected: value } : {}),
      ...(document?.isResureSignDoc ? { resureSignSelected: updatedResureSign } : {}),
      documentNames: isItPresentInTheSelectedDoc
        ? (data?.documentNames || [])?.filter((doc) => doc?.documentId !== documentId) // 🔄 Remove if unchecked
        : [...(data?.documentNames || []), { documentId, documentName }], // ✅ Add if checked
    });
  };

  const handleSelectAll = ({ value, element = [], type }) => {
    if (value) {
      if (type === "CLIENT DOCUMENT") {
        // Map to include both documentId and sentBy for CLIENT DOCUMENT
        const clientDocumentObjects = element.map((document) => ({
          documentId: document._id, // Assuming _id is used as documentId
          sentBy: buyerCustomerDocsContractTypes.includes(document?.contractType) ? "BUYER_AGENT" : "SELLER_AGENT",
        }));
        const documentNames =
          element.map((doc) => {
            return {
              documentName: formatDocName(doc, { nameKey: "contractName" }),
              documentId: doc._id,
            };
          }) || [];

        setData((prevData) => ({
          ...prevData,
          clientDocumentSelected: clientDocumentObjects,
          documentNames: [...(prevData?.documentNames || []), ...documentNames],
        }));
      } else {
        // Handle other types
        let documentNames = [];
        const allDocumentIds = [];
        const resureSignIds = [];
        element?.forEach((document) => {
          const documentId = type === "DOCUMENT" ? document.documentId : document._id;
          if (document?.isResureSignDoc) resureSignIds.push(documentId);
          allDocumentIds.push(documentId);
          documentNames?.push({
            documentName: formatDocName(document, { nameKey: "contractName" }),
            documentId: documentId,
          });

          document?.matchedDocuments?.forEach((ele) => {
            const matchedDocumentId = type === "DOCUMENT" ? ele?.documentId : ele?._id;
            if (ele?.isResureSignDoc) resureSignIds.push(matchedDocumentId);
            allDocumentIds.push(matchedDocumentId);
            documentNames?.push({
              documentName: formatDocName(ele, { nameKey: "contractName" }),
              documentId: matchedDocumentId,
            });
          });
        });

        setData((prevData) => ({
          ...prevData,
          documentNames: [...(prevData?.documentNames || []), ...documentNames],
          ...(type === "DOCUMENT" ? { documentSelected: allDocumentIds } : type === "SHARED" ? { sharedSelected: allDocumentIds } : type === "DOCUMENT_WITHOUT_BUYERS" ? { documentWithoutBuyerSelected: allDocumentIds } : type === "CUSTOMER_DOCUMENTS" ? { customerDocumentSelected: allDocumentIds } : { propertyDocsSelected: allDocumentIds.filter((id) => !resureSignIds.includes(id)) }),
          resureSignSelected: [...new Set([...(prevData?.resureSignSelected || []), ...resureSignIds])]
        }));
      }
    } else {
      // Handle the case where value is false
      const idsToRemove = new Set();
      const resureSignToRemove = [];
      element?.forEach((document) => {
        const documentId = type === "CLIENT DOCUMENT" ? document?._id : type === "DOCUMENT" ? document?.documentId : document?._id;
        idsToRemove.add(documentId);
        if (document?.isResureSignDoc) resureSignToRemove.push(documentId);
        document?.matchedDocuments?.forEach((ele) => {
          const matchedDocId = type === "DOCUMENT" ? ele?.documentId : ele?._id;
          idsToRemove.add(matchedDocId);
        });
      });

      setData((prevData) => ({
        ...prevData,
        documentNames: (prevData?.documentNames || [])?.filter((doc) => !idsToRemove.has(doc?.documentId)),
        ...(type === "DOCUMENT"
          ? { documentSelected: [] }
          : type === "SHARED"
          ? { sharedSelected: [] }
          : type === "CLIENT DOCUMENT"
          ? { clientDocumentSelected: [] }
          : type === "DOCUMENT_WITHOUT_BUYERS"
          ? { documentWithoutBuyerSelected: [] }
          : type === "CUSTOMER_DOCUMENTS"
          ? { customerDocumentSelected: [] }
          : { propertyDocsSelected: [] }),
        resureSignSelected: (prevData?.resureSignSelected || []).filter((id) => !resureSignToRemove.includes(id)),
      }));
    }
  };

  

  const countAllDocsLength = (docsArray = []) => {
    let count = 0;
    docsArray?.forEach((doc) => {
      count++;
      doc?.matchedDocuments?.forEach((ele) => count++);
    });
    return count;
  };

  return (
    <div style={{ width: "100%" }}>
      {personDocsLoading ? (
        <div style={{ height: "300px", display: "flex", justifyContent: "center", alignItems: "center" }}>
          <Spin size="medium" />
        </div>
      ) : personDocsError ? (
        ""
      ) : (
        clientDocs?.length > 0 && (
          <div>
            <div style={{ overflow: "hidden" }}>
              <div>
                <div style={{ display: "flex", justifyContent: "space-between", fontWeight: "bold", color: "grey" }}>
                  <p className={styles.documentHeader}>Client Documents:</p>

                  <Checkbox onChange={(e) => handleSelectAll({ value: e.target.checked, element: clientDocs, type: "CLIENT DOCUMENT" })} checked={data?.clientDocumentSelected?.length === clientDocs?.length} style={{ width: isSmallScreen ? "50%" : isMediumScreen ? "30%" : "15%" }}>
                    <text className={styles.documentHeader} style={{ color: "grey" }}>
                      Select All
                    </text>
                  </Checkbox>
                </div>
                {clientDocs?.map((document, index) => (
                  <div key={index} style={{ margin: "0px 0 10px 20px", display: "flex", flexDirection: "column" }}>
                    {document?.isSecondLevel && (
                      <>
                        <div style={{ marginLeft: "20px" }}>
                          <Checkbox style={{ marginRight: "10px" }} checked={data?.clientDocumentSelected?.some((item) => item.documentId === document._id)} onChange={() => handleClientDocChange(document._id, buyerCustomerDocsContractTypes.includes(document?.contractType) ? "BUYER_AGENT" : "SELLER_AGENT", document)}>
                            <text className={styles.docName}> {document?.updatedName || document?.contractName}
                            {document?.updatedName && (
                              <>
                              <br />
                              <span style={{marginLeft:"25px", fontSize: "13px"}}>
                                ({document?.contractName})
                              </span>
                              </>
                            )}
                            </text>
                          </Checkbox>
                        </div>
                      </>
                    )}
                    {!document.isSecondLevel && (
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <Checkbox style={{ marginRight: "10px" }} checked={data?.clientDocumentSelected?.some((item) => item.documentId === document._id)} onChange={() => handleClientDocChange(document._id, buyerCustomerDocsContractTypes.includes(document?.contractType) ? "BUYER_AGENT" : "SELLER_AGENT", (document))}>
                        <ContractTypeBadge contractType={document?.contractType} additionalStyle={{ fontSize: "12px" }} />
                          <text className={styles.docName}> {document?.updatedName || document.contractName}
                          {document?.updatedName && (
                                <>
                                <br />
                                <span style={{marginLeft:"25px", fontSize: "13px"}}>
                                  ({document?.contractName})
                                </span>
                                </>
                              )}
                          </text>
                        </Checkbox>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        )
      )}

      {/* // Property documents list  */}
      {propertDocsLoading ? (
        <div className={styles.spin}>
          <Spin size="medium" />
        </div>
      ) : propertDocsError ? (
        ""
      ) : (
        propertyDocs?.length > 0 && (
          <div>
            <div style={{ overflow: "hidden" }}>
              {transactionAndPropertyDocs?.length > 0 ? (
                <div>
                  <div style={{ display: "flex", justifyContent: "space-between", fontWeight: "bold", color: "grey" }}>
                    <p className={styles.documentHeader}>Transaction & Property Documents:</p>
                    <Checkbox
                      onChange={(e) =>
                        handleSelectAll({
                          value: e.target.checked,
                          element: transactionAndPropertyDocs,
                          type: "PROPETY_DOC",
                        })
                      }
                      style={{ width: isSmallScreen ? "50%" : isMediumScreen ? "30%" : "15%" }}
                      checked={data?.propertyDocsSelected?.length === countAllDocsLength(transactionAndPropertyDocs)}
                    >
                      <text className={styles.documentHeader}>Select All</text>
                    </Checkbox>
                  </div>
                  {transactionAndPropertyDocs.map((document, index) => {
                    return (
                      <div>
                        <div key={index} style={{ margin: "0px 0 10px 20px", display: "flex", alignItems: "center" }}>
                          <Checkbox
                            style={{ marginRight: "10px" }}
                            checked={
                              document?.isResureSignDoc
                                ? data?.resureSignSelected?.includes(document._id) // ✅ show checked for resureSignDoc
                                : data?.propertyDocsSelected?.includes(document._id)
                            }
                            onChange={() => handlePropertyDocs(document._id, "PROPETY_DOC", document)}
                          >
                            {document?.isResureSignDoc || document?.fileType === "PDF" ? (
                                <FaRegFilePdf
                                  style={{
                                    color: "red",
                                    top: "4px",
                                    fontSize: "18px",
                                    position: "relative",
                                  }}
                                />
                              ) : document?.fileType === "IMAGE" ? (
                                <FileImageOutlined
                                  style={{
                                    color: "#ecd540",
                                    marginTop: "5px",
                                    marginRight: "5px",
                                    fontSize: "18px",
                                  }}
                                />
                              ) : null}
                            <ContractTypeBadge contractType={document?.contractType} additionalStyle={{ fontSize: "12px" }} />
                            <text className={styles.docName}>
                              {" "}
                              {document?.updatedName || formatBaseName(document)} {moment(document?.createdDateMili).format("MM/DD/YYYY")} at {moment(document?.createdDateMili).format("hh:mm A")}
                              {document?.updatedName && (
                                <div>
                                  <span style={{ marginLeft: "25px", fontSize: "13px" }}>({document?.contractId ? document?.documentName : document?.fileName})</span>
                                </div>
                              )}
                            </text>
                          </Checkbox>
                        </div>
                        {document?.matchedDocuments?.map((nestedElement, idx) => {
                          return (
                            <div style={{ marginLeft: "30px" }}>
                              <div key={index + "" + idx} style={{ margin: "0px 0 10px 20px", display: "flex", alignItems: "center" }}>
                                <Checkbox style={{ marginRight: "10px" }} checked={data?.propertyDocsSelected?.includes(nestedElement._id)} onChange={() => handlePropertyDocs(nestedElement._id, "PROPETY_DOC", nestedElement)}>
                                  {nestedElement?.updatedName || formatBaseName(nestedElement)} {moment(nestedElement?.createdDateMili).format("MM/DD/YYYY")} at {moment(nestedElement?.createdDateMili).format("hh:mm A")}
                                  {nestedElement?.updatedName && (
                                    <div>
                                      <span style={{ marginLeft: "25px" }}>({nestedElement?.documentName})</span>
                                    </div>
                                  )}
                                </Checkbox>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    );
                  })}
                </div>
              ) : null}

              {/* Section for Documents without Buyers */}
              {withoutBuyerDocs.length > 0 && (
                <div style={{ padding: "10px" }}>
                  {otherDocsContractTypes.includes(rootDocData?.contractType) ? null : (
                    <div style={{ display: "flex", height: "40px", justifyContent: "space-between", fontWeight: "bold", color: "grey" }}>
                      <p className={styles.documentHeader}>{"Documents without Buyers:"} </p>
                      <Checkbox
                        onChange={(e) =>
                          handleSelectAll({
                            value: e.target.checked,
                            element: withoutBuyerDocs,
                            type: "DOCUMENT_WITHOUT_BUYERS",
                          })
                        }
                        checked={data?.documentWithoutBuyerSelected?.length === withoutBuyerDocs.length}
                        style={{ width: isSmallScreen ? "50%" : isMediumScreen ? "30%" : "15%" }}
                      >
                        <text className={styles.documentHeader} style={{ color: "grey" }}>
                          Select All
                        </text>
                      </Checkbox>
                    </div>
                  )}

                  {withoutBuyerDocs.map((document, index) => (
                    <div key={index} style={{ margin: "0px 0 10px 20px", display: "flex", alignItems: "center" }}>
                      <Checkbox style={{ marginRight: "10px" }} checked={data?.documentWithoutBuyerSelected?.includes(document._id)} onChange={() => handlePropertyDocs(document._id, "DOCUMENT_WITHOUT_BUYERS", document)}>
                      { document?.fileType === "PDF" ? (
                                <FaRegFilePdf
                                  style={{
                                    color: "red",
                                    top: "4px",
                                    fontSize: "18px",
                                    position: "relative",
                                  }}
                                />
                              ) : document?.fileType === "IMAGE" ? (
                                <FileImageOutlined
                                  style={{
                                    color: "#ecd540",
                                    marginTop: "5px",
                                    marginRight: "5px",
                                    fontSize: "18px",
                                  }}
                                />
                              ) : null}
                      <ContractTypeBadge contractType={document?.contractType} additionalStyle={{ fontSize: "12px" }} />
                        <text className={styles.docName}> { document?.updatedName || formatBaseName(document)} {moment(document?.createdDateMili).format("MM/DD/YYYY")} at {moment(document?.createdDateMili).format("hh:mm A")}
                       {" "}
                        {document?.updatedName && (
                                <>
                                <br />
                                <span style={{marginLeft:"25px", fontSize: "13px"}}>
                                  ({document?.contractId ? document?.documentName : document?.fileName})
                                </span>
                                </>
                              )}
                        </text>
                      </Checkbox>
                    </div>
                  ))}
                </div>
              )}
              {screenSource !== "CLIENT_DOC" && contactDocs?.length > 0 && (
                <div>
                  <div style={{ overflow: "hidden" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", fontWeight: "bold", color: "grey", padding: "0px 10px 0px 0px" }}>
                      <p>Customer Documents:</p>
                      <Checkbox onChange={(e) => handleSelectAll({ value: e.target.checked, element: contactDocs, type: "CUSTOMER_DOCUMENTS" })} checked={data?.customerDocumentSelected?.length === countAllDocsLength(contactDocs)}>
                        <span style={{ color: "grey" }}>Select All</span>
                      </Checkbox>
                    </div>
                    {contactDocs?.map((document, index) => {
                      return (
                        <div>
                          <div key={index} style={{ margin: "0px 0 10px 20px", display: "flex", alignItems: "center" }}>
                            <Checkbox style={{ marginRight: "10px" }} checked={data?.customerDocumentSelected?.includes(document._id)} onChange={() => handleCustomerDocs(document._id, document)}>
                             { document?.fileType === "PDF" ? (
                                <FaRegFilePdf
                                  style={{
                                    color: "red",
                                    top: "4px",
                                    fontSize: "18px",
                                    position: "relative",
                                  }}
                                />
                              ) : document?.fileType === "IMAGE" ? (
                                <FileImageOutlined
                                  style={{
                                    color: "#ecd540",
                                    marginTop: "5px",
                                    marginRight: "5px",
                                    fontSize: "18px",
                                  }}
                                />
                              ) : null}
                            <ContractTypeBadge contractType={document?.contractType} additionalStyle={{ fontSize: "12px" }} />
                             {" "}
                              {document?.updatedName || formatBaseName(document)} {moment(document?.createdDateMili).format("MM/DD/YYYY")} at {moment(document?.createdDateMili).format("hh:mm A")}
                              {document?.updatedName && (
                                <>
                                <br />
                                <span style={{marginLeft:"25px", fontSize: "13px"}}>
                                  ({document?.documentName})
                                </span>
                                </>
                              )}
                            </Checkbox>
                          </div>

                          {document?.matchedDocuments?.map((nestedElement, idx) => {
                            return (
                              <div style={{ marginLeft: "30px" }}>
                                <div key={index + "" + idx} style={{ margin: "0px 0 10px 20px", display: "flex", alignItems: "center" }}>
                                  <Checkbox style={{ marginRight: "10px" }} checked={data?.customerDocumentSelected?.includes(nestedElement._id)} onChange={() => handleCustomerDocs(nestedElement._id, nestedElement)}>
                                    {nestedElement?.updatedName || formatBaseName(nestedElement)} {moment(nestedElement?.createdDateMili).format("MM/DD/YYYY")} at {moment(nestedElement?.createdDateMili).format("hh:mm A")}
                                    {nestedElement?.updatedName && (
                                      <>
                                      <br />
                                      <span style={{marginLeft:"25px"}}>
                                        ({nestedElement?.documentName})
                                      </span>
                                      </>
                                    )}
                                  </Checkbox>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
          </div>
        )
      )}
      {/* shared document list  */}
      {sharedDocsLoading ? (
        <div className={styles.spin}>
          <Spin size="medium" />
        </div>
      ) : sharedDocsError ? (
        ""
      ) : (
        sharedDocs?.length > 0 && (
          <div>
            <div style={{ overflow: "hidden" }}>
              <div style={{ padding: "10px" }}>
                <div style={{ display: "flex", justifyContent: "space-between", fontWeight: "bold", color: "grey" }}>
                  <p className={styles.documentHeader}>Shared Documents:</p>
                  <Checkbox onChange={(e) => handleSelectAll({ value: e.target.checked, element: sharedDocs, type: "SHARED" })} checked={data?.sharedSelected?.length === sharedDocs?.length} style={{ width: isSmallScreen ? "50%" : isMediumScreen ? "30%" : "15%" }}>
                    <text className={styles.documentHeader} style={{ color: "grey" }}>
                      Select All
                    </text>
                  </Checkbox>
                </div>
                {sharedDocs?.map((document, index) => (
                  <div key={index} style={{ margin: "0px 0 10px 20px", display: "flex", alignItems: "center" }}>
                    <Checkbox style={{ marginRight: "10px" }} checked={data?.sharedSelected?.includes(document._id)} onChange={() => handleSharedDocs(document._id, document)}>
                      { document?.fileType === "PDF" ? (
                                <FaRegFilePdf
                                  style={{
                                    color: "red",
                                    top: "4px",
                                    fontSize: "18px",
                                    position: "relative",
                                  }}
                                />
                              ) : document?.fileType === "IMAGE" ? (
                                <FileImageOutlined
                                  style={{
                                    color: "#ecd540",
                                    marginTop: "5px",
                                    marginRight: "5px",
                                    fontSize: "18px",
                                  }}
                                />
                              ) : null}
                              {" "}
                      {document?.updatedName || document?.fileName}
                      {document?.updatedName && (
                        <>
                        <br />
                        <span style={{marginLeft:"25px", fontSize: "13px"}}>
                          ({document?.fileName})
                        </span>
                        </>
                      )}
                    </Checkbox>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )
      )}
    </div>
  );
};

export default DocumentList;
